export default __webpack_public_path__ + "static/media/estimates.e85e33a7.svg";